(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
      return;
    }
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    function initProductGalleries(root) {
      var scope = root || document;

      scope.querySelectorAll('[data-pf-product-gallery]').forEach(function (gallery) {
        if (gallery.dataset.pfGalleryReady === 'true') return;

        var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-pf-product-media]'));
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pf-product-thumb]'));

        if (!mediaItems.length) return;

        gallery.dataset.pfGalleryReady = 'true';
        gallery.classList.add('is-enhanced');

        function setActive(mediaId) {
          var targetId = mediaId;
          var hasTarget = mediaItems.some(function (item) {
            return item.dataset.pfProductMedia === targetId;
          });

          if (!hasTarget) {
            targetId = mediaItems[0].dataset.pfProductMedia;
          }

          mediaItems.forEach(function (item) {
            var isActive = item.dataset.pfProductMedia === targetId;
            item.classList.toggle('is-active', isActive);
            item.hidden = !isActive;
            item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });

          thumbs.forEach(function (thumb) {
            var isActive = thumb.dataset.pfProductThumb === targetId;
            thumb.classList.toggle('is-active', isActive);

            if (isActive) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (event) {
            event.preventDefault();
            setActive(thumb.dataset.pfProductThumb);
          });
        });

        setActive(mediaItems[0].dataset.pfProductMedia);
      });
    }

    var header = document.querySelector('[data-pf-header]');
    var menuToggle = document.querySelector('[data-pf-menu-toggle]');

    if (header && menuToggle) {
      menuToggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    document.querySelectorAll('[data-pf-dropdown]').forEach(function (dropdown) {
      var toggle = dropdown.querySelector('[data-pf-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-pf-dropdown-menu]');

      if (!toggle || !menu) return;

      toggle.addEventListener('click', function () {
        var isOpen = dropdown.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      dropdown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          dropdown.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-pf-dropdown].is-open').forEach(function (dropdown) {
        if (!dropdown.contains(event.target)) {
          var toggle = dropdown.querySelector('[data-pf-dropdown-toggle]');
          dropdown.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.querySelectorAll('[data-pf-hero]').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-pf-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-pf-hero-dot]'));
      var current = 0;
      var timer = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === current);
          slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === current);
          dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          show(index);
        });
      });

      show(0);

      if (slides.length > 1 && hero.dataset.pfAutoplay === 'true' && !reducedMotion) {
        timer = window.setInterval(function () {
          show(current + 1);
        }, 6000);

        hero.addEventListener('mouseenter', function () {
          window.clearInterval(timer);
        });
        hero.addEventListener('mouseleave', function () {
          timer = window.setInterval(function () {
            show(current + 1);
          }, 6000);
        });
      }
    });

    initProductGalleries(document);

    document.addEventListener('shopify:section:load', function (event) {
      initProductGalleries(event.target);
    });
  });
})();
